import { FC } from 'react';

import HistoryMovementsViewCollapsedTableHeader from './HistoryMovementsViewCollapsedTableHeader';

const HistoryMovementsViewCollapsedTable: FC = () => (
  <table className="table mb-0" id="collapsed-table">
    <HistoryMovementsViewCollapsedTableHeader />
  </table>
);

export default HistoryMovementsViewCollapsedTable;
